import { useEffect, useState } from 'react';
import { useAfterInit } from '../hooks/useAfterInit';

const Pagination = (props) => {
    const { total, onChange, itemsPerPage = 1000 } = props;
    const [currentPageIndex, setCurrentPageIndex] = useState(0);
    const pages = Math.ceil(total / itemsPerPage);
    const [pageList, setPageList] = useState([]);

    useEffect(() => {
        const pageArr = [];
        for (let p = 1; p < pages + 1; p++) pageArr.push(p);
        setPageList(pageArr);
        setCurrentPageIndex(0);
    }, [total]);

    useAfterInit(() => {
        onChange(currentPageIndex);
    }, [currentPageIndex]);
    if (total === 0) return null;
    return (
        <div id="pagination">
            <span className="page-buttons">
                {pageList.length > 1 &&
                    pageList.map((p, i) => {
                        return (
                            <button key={i} className={'page-btn' + (currentPageIndex === i ? ' active' : '')} onClick={() => setCurrentPageIndex(i)}>
                                {p}
                            </button>
                        );
                    })}
            </span>
            <span className="page-text">
                {currentPageIndex * itemsPerPage + 1} - {Math.min((currentPageIndex + 1) * itemsPerPage - 1, total)}
            </span>
        </div>
    );
};
export default Pagination;
